import { render, staticRenderFns } from "./exportProvinceReportCopy1.vue?vue&type=template&id=89a7ec04&scoped=true"
import script from "./exportProvinceReportCopy1.vue?vue&type=script&lang=js"
export * from "./exportProvinceReportCopy1.vue?vue&type=script&lang=js"
import style0 from "./exportProvinceReportCopy1.vue?vue&type=style&index=0&id=89a7ec04&prod&scoped=true&lang=css"
import style1 from "./exportProvinceReportCopy1.vue?vue&type=style&index=1&id=89a7ec04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a7ec04",
  null
  
)

export default component.exports